import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Grid from "../../../components/grid";
import { ESTILO_BOTON_LISTAR_ATRAS, ESTILO_BOTON_LISTAR_NUEVO, ESTILO_BOTON_MODAL_ACEPTAR } from "../../../utils/const/estilos-const";
import ModalConfirmar from "../../../components/modal-confirmar";
import "../../../style/style-cargando.css";
import cargandoCard from "../../../components/cargando-card";
import sinAccesoCard from "../../../components/sin-acceso-card";
import { Settings } from "feather-icons-react/build/IconComponents";
import { sharedNextPage } from "../../../utils/shared-functions";
import { SELECT_HABILITADO_DESHABILITADO } from "../../../utils/const/const-select-habilitado-deshabilitado";
import Select from "react-select";
import { deshabilitarUsuarioMovil, habilitarUsuarioMovil, obtenerListaUsuarioMovil } from "../../../api/api-usuario-movil";

let accesoBotonNuevo = '';


export default function ListarUsuarioMovil() {
  const headers = [
    { key: "acciones", title: "ACCIONES" },
    { key: "id", title: "ID", visible: false, },
    { key: "conductor", title: "CONDUCTOR", visible: true, filter: true, editLabel: true, },
    { key: "vehiculo", title: "VEHICULO", visible: true, filter: true, },
    { key: "ciudad", title: "CIUDAD", visible: true, filter: true, },
    { key: "rol", title: "ROL", visible: true, filter: true, },
    { key: "usuario", title: "USUARIO", visible: true, filter: true, },
    { key: "password", title: "PASSWORD", visible: true, filter: true, },
    { key: "fechaProceso", title: "FECHA PROCESO", visible: true, filter: true },
  ];
  const history = useHistory();
  const [cargandoPage, setCargandoPage] = useState(true);
  const [listaElementos, setListaElementos] = useState([]);
  const [modalConfirmarDeshabilitarVisible, setModalConfirmarDeshabilitarVisible] = useState(false);
  const [modalConfirmarHabilitarVisible, setModalConfirmarHabilitarVisible] = useState(false);
  const [elementoSelected, setElementoSelected] = useState(null);
  // const [permisos, setPermisos] = useState(null);
  const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(true);
  const [habilitadoSelected, setHabilitadoSelected] = useState(null);

  useEffect(() => {
    iniciar();
  }, []);

  const iniciar = async () => {
    try {
      let objEnviar = {};
      objEnviar.habilitado = habilitadoSelected !== null ? habilitadoSelected.value : null;
      /*obj.idMenuPrimerNivel = INT_ID_MODULO_CHECKLIST;
      obj.idMenuSegundoNivel = INT_ID_SEGUNDO_NIVEL_ADMINISTRACION_CHECKLIST;
      obj.idMenuTercerNivel = INT_ID_TERCER_NIVEL_CHECKLIST_OPCIONES_RESPUESTA;
      let obtenerPermisos = await obtenerPermisosPorNivelUsuarioWeb(obj);
      let permiso = obtenerPermisos[0];
      setPermisos(permiso);
      */
      let permiso = null;
      let lista = [];

      accesoBotonNuevo = '';
      setTieneAccesoAlModulo(true);
      lista = await obtenerListaUsuarioMovil(objEnviar);


      agregarAccionesALista(lista, permiso);
      setCargandoPage(false);
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
      setCargandoPage(false);
    }
  }

  const agregarAccionesALista = (lista, permiso) => {
    try {
      // console.log('agregarAccionesALista');
      // console.log(lista);
      if (lista.length === 0) {
        setListaElementos(lista);
      }
      if (lista.length > 0) {
        const objModificar = {
          label: "Modificar",
          color: "green",
          onClick: (param) => editarElementoSelected(param),
        };
        const objDeshabilitar = {
          label: "Deshabilitar",
          color: "red",
          onClick: (param) => cambiarEstadoDeshabilitar(param),
        };
        const objHabilitar = {
          label: "Habilitar",
          color: "red",
          onClick: (param) => cambiarEstadoHabilitar(param),
        };
        // if (idTipoUsuario !== INT_TIPO_USUARIO_ADMINISTRADOR_WEB) {
        // if (permiso.nuevo === TRUE) {
        accesoBotonNuevo = '';
        // }
        // }
        for (let i = 0; i < lista.length; i++) {
          const element = lista[i];
          let acciones = [];
          acciones.push(objModificar);
          if (element.estado === 1) {
            acciones.push(objDeshabilitar);
          }
          if (element.estado === 0) {
            acciones.push(objHabilitar);
          }
          lista[i].acciones = acciones;
        }
        setListaElementos(lista);
      }
    } catch (err) {
      console.log('agregarAccionesALista err');
      console.log(err);
    }
  }

  const editarElementoSelected = (data) => {
    try {
      // console.log("editarElementoSelected");
      // console.log(data);
      if (data.acciones !== undefined) {
        delete data.acciones;
      }
      let obj = {};
      obj.titulo = "MODIFICAR CONDUCTOR";
      obj.formData = data;
      // console.log('obj');
      // console.log(obj);
      sharedNextPage("usuario-movil", obj, history);
    } catch (err) {
      console.log("editarElementoSelected err");
      console.log(err);
    }
  };

  const cambiarEstadoDeshabilitar = async (data) => {
    try {
      // console.log("cambiarEstadoDeshabilitar");
      // console.log(data);
      setElementoSelected(data);
      setModalConfirmarDeshabilitarVisible(true);
    } catch (err) {
      console.log("cambiarEstadoDeshabilitar err");
      console.log(err);
    }
  };

  const cambiarEstadoHabilitar = async (data) => {
    try {
      // console.log("cambiarEstadoHabilitar");
      // console.log(data);
      setElementoSelected(data);
      setModalConfirmarHabilitarVisible(true);
    } catch (err) {
      console.log("cambiarEstadoHabilitar err");
      console.log(err);
    }
  };

  const handleNuevoClick = () => {
    // console.log("handleNuevoClick");
    let obj = {};
    let data = {};
    data.id = 0;
    data.usuario = "";
    data.password = "";
    data.idVehiculo = null;
    data.idConductor = null;
    data.idRol = null;
    data.idCiudad = null;
    obj.titulo = "REGISTRAR NUEVO USUARIO";
    obj.formData = data;
    sharedNextPage("usuario-movil", obj, history);
  };

  const handleAtrasClick = () => {
    history.goBack();
  };

  const reset = async () => {
    setCargandoPage(true);
    iniciar();
  };

  const handleConfirmDeshabilitarModal = async () => {
    setModalConfirmarDeshabilitarVisible(false);
    if (elementoSelected == null) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = elementoSelected.id;
    if (elementoSelected.id !== 0) {
      const response = await deshabilitarUsuarioMovil(objEnviar);
      // console.log('creado');
      // console.log(creado);
      if (response.error === false) {
        alert('Se deshabilito correctamente');
        reset();
      }
      if (response.error === true) {
        alert('No se pudo deshabilitar');
      }
    }
  };

  const handleConfirmHabilitarModal = async () => {
    setModalConfirmarHabilitarVisible(false);
    if (elementoSelected == null) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = elementoSelected.id;
    if (elementoSelected.id !== 0) {
      // console.log('crear correo');
      const response = await habilitarUsuarioMovil(objEnviar);
      // console.log('creado');
      // console.log(creado);
      if (response.error === false) {
        alert('Se habilito correctamente');
        reset();
      }
      if (response.error === true) {
        alert('No se pudo habilitar');
      }
    }
  };

  const render = () => {
    try {
      if (cargandoPage === true) {
        return cargandoCard();
      }
      if (tieneAccesoAlModulo === false) {
        return sinAccesoCard();
      }
      return (
        <div>
          <div className="pt-4 px-4 flex justify-between">
            <label
              style={{
                paddingLeft: 10,
                fontWeight: 'bold',
              }}
            >
              GESTIONAR USUARIO MOVIL
            </label>
            <div className="flex justify-center">
              <button
                type="button"
                className={ESTILO_BOTON_LISTAR_NUEVO}
                onClick={handleNuevoClick}
                style={{
                  display: accesoBotonNuevo,
                }}
              >
                NUEVO
              </button>
              <button
                type="button"
                className={ESTILO_BOTON_LISTAR_ATRAS}
                onClick={handleAtrasClick}
              >
                ATRAS
              </button>
              <button
                type="button"
                className={ESTILO_BOTON_LISTAR_ATRAS}
                onClick={handleAtrasClick}
              >
                <Settings />
              </button>
            </div>
          </div>
          <div className="grid grid-cols-12 gap-4 mx-5">
            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
              <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="habilitado">
                ESTADO
              </label>
              <Select options={SELECT_HABILITADO_DESHABILITADO} isSearchable='true'
                isClearable='true'
                value={habilitadoSelected}
                onChange={(event) => setHabilitadoSelected(event)}
                placeholder='SELECCIONE HABILITADO'
              />
            </div>
            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
              <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="habilitado">
                &nbsp;
              </label>
              <button
                type="button"
                className={ESTILO_BOTON_MODAL_ACEPTAR}
                onClick={() => { reset(); }}
                style={{
                  // display: accesoBotonNuevo,
                }}
              >
                BUSCAR
              </button>
            </div>
          </div>
          <Grid rows={listaElementos} headers={headers} />
          <ModalConfirmar
            isOpen={modalConfirmarDeshabilitarVisible}
            onCancel={() => { setModalConfirmarDeshabilitarVisible(false); }}
            onConfirm={handleConfirmDeshabilitarModal}
            message="¿Estás de deshabilitar Usuario?"
          />
          <ModalConfirmar
            isOpen={modalConfirmarHabilitarVisible}
            onCancel={() => { setModalConfirmarHabilitarVisible(false); }}
            onConfirm={handleConfirmHabilitarModal}
            message="¿Estás de habilitar Usuario?"
          />
        </div>
      );
    } catch (err) {
      console.log('ListarUsuarioMovil render err');
      console.log(err);
      return (
        <div><label>{JSON.stringify(err)}</label></div>
      );
    }
  }

  return render();
}
